import { createAction, props } from '@ngrx/store';
import { UserProfile } from 'src/app/core/models/user/user-profile.model';
import { UserProperty } from 'src/app/core/models/user/user-property.model';

export const loadUser = createAction('[singedIn Event] load user')

export const offloadUser = createAction('[singedOut Event] offload user')

export const userLoaded = createAction(
    '[load user] user loaded',
    props<{ profile: UserProfile }>()
)

export const userLoadFailed = createAction(
    '[load user] user load failed',
    props<{ error: Error }>()
)

export const updateUserProperties = createAction(
    '[Shared] update user properties',
    props<{ properties: UserProperty[], version: number }>()
)

export const userPropertyUpdated = createAction(
    '[Shared] update user property',
    props<{ property: UserProperty }>()
)